import type { FormInstance } from 'antd';

interface ITransformAndSetFiltersOptions {
  preserveFalseKeys?: boolean;
}

export const transformAndSetFilters = <T>(
  form: FormInstance,
  setFilters: (v: T | undefined) => void,
  options?: ITransformAndSetFiltersOptions,
) => {
  const values = form.getFieldsValue();

  if (values) {
    Object.keys(values).forEach((key) => {
      const shouldPreserveFalse = values[key] === false && options?.preserveFalseKeys;

      if ((!values[key] && !shouldPreserveFalse) || (Array.isArray(values[key]) && !values[key].length)) {
        delete values[key];
      }
      // if (typeof values[key] === 'object' ) delete values[key];
    });

    setFilters(Object.keys(values).length ? values : undefined);
  } else {
    setFilters(undefined);
  }
};
